import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

export const TREE_ITEM_HEIGHT = 56;
export const LIST_COLUMN_WIDTH = 380;

export const PlanOverviewListContainer = styled(Grid)`
  height: 100%;
  min-width: ${LIST_COLUMN_WIDTH}px !important;
  width: ${LIST_COLUMN_WIDTH}px !important;
  background-color: ${RoutalPalette.neutral00};
  border-right: 1px solid ${RoutalPalette.neutral10};
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 44px;
    width: ${LIST_COLUMN_WIDTH}px;
    height: 90px;
    background: linear-gradient(0deg, ${RoutalPalette.neutral00}, ${RoutalPalette.neutral00}00);
    pointer-events: none;
  }

  [role='tree'] {
    outline: none !important;
  }

  [role='treeitem'] {
    transition: top 0.07s ease-in;
    outline: none !important;
  }
`;
